import React from "react";
import { Table, Tooltip } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import TranslationKeysForm from './../../../forms/localization-forms/translation-keys-form/';
import EditModal from './../../../service/edit-modal';
import mobileSize from "../../../../utils/mobile-size";
import KeyTranslation from '../../../service/key-translation';
import SkeletonTable from '../../../service/skeleton-table';
import "./translation-keys-table.scss"




const { Column } = Table;


const TranslationKeysTable = ({ dataQuery, loadingQuery, pagination, handleTableChange, rowCount }) => {

  return (

    <div className="holder-table">
      <Table size={ mobileSize('small') }
        className="main-table translation-keys-table"
        tableLayout={ mobileSize(true, 1300) ? '' : 'fixed' }
        loading={ { spinning: loadingQuery, indicator: <SkeletonTable rowCount={ rowCount } columns={ "".split.call(Array(5), ",") } /> } }
        onChange={
          (pagination, filters, sorter, page) =>
            handleTableChange({ pagination, filters, sorter, page })
        }
        dataSource={ dataQuery }
        rowKey={ key => key.id }
        pagination={ pagination }
        sortDirections={ [ 'ascend', 'descend', 'ascend' ] }
      >
        <Column
          className="column-width-70"
          title="ID" key="id" dataIndex="id" sorter="true" />
        <Column
          title={ <KeyTranslation keyTranslation="table.global.column.head.key" defaultValue="Key" /> }
          key="key" dataIndex="key" sorter="true" width={ 300 } />
        <Column
          className="column-width-100"
          title={ <KeyTranslation keyTranslation="table.global.column.head.type" defaultValue="Type" /> }
          key="type"
          dataIndex="type"
          filterMultiple={ false }
          filters={ [
            { text: "Admin", value: "admin" },
            { text: "Site", value: "site" },
            { text: "Core", value: "core" },
          ] }
        />
        <Column
          title={ <KeyTranslation keyTranslation="table.global.column.head.description" defaultValue="Description" /> }
          key="description"
          className="column-description"
          render={
            key =>
              <>
                <div style={ { position: 'absolute' } }>
                  <Tooltip overlayClassName='tooltip-width' title={ <pre>{ key.type === 'core' ? key.help : key.description }</pre> }>
                    <QuestionCircleOutlined />
                  </Tooltip>
                </div>
                <div style={ { marginLeft: '30px' } }>
                  <span>{ key.description }</span>
                </div>
              </>
          } />
        <Column
          title={ <KeyTranslation keyTranslation="table.global.column.head.action" defaultValue="Action" /> }
          key="action"
          className="column-child"
          render={
            key => (
              <>
                <EditModal key="0" valueBtn={ 'Edit key' } titleModal={ 'Update Translation Key' }>
                  <TranslationKeysForm dataQuery={ key } loadingQuery={ loadingQuery } />
                </EditModal>
              </>
            )
          }
        />
      </Table>
    </div>
  );
};

export default TranslationKeysTable;